import styled from "styled-components";
import React from "react";
import {Pagination} from "./Pagination";

const Wrapper = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  white-space: break-spaces;
`


const PaginationWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
`

export const TopBar = ({tableInstance}) => {
    const {data, state:{pageSize, pageIndex}, page} = tableInstance;
    const totalResult = data.length;
    let firstResultIndex = (pageIndex*pageSize)+1;
    let lastResultIndex = (pageIndex*pageSize)+page.length;
    return (
        <Wrapper>
            <div>
                Showing results <strong>{firstResultIndex }</strong>-<strong>{lastResultIndex}</strong>  of  <strong>{totalResult}</strong>  total results
            </div>
            <PaginationWrapper>
                <Pagination tableInstance={tableInstance}/>
            </PaginationWrapper>
        </Wrapper>
    );
};
